import { UpdateSettingsProps } from '~/definitions/generalSettings';
import { getStore } from '~/mobx/AppStore';

const updateRegionAttributeData = async (assignedItems?: UpdateSettingsProps[]) => {
    const { generalSettingsStore } = getStore();
    const { regionName, regionSettingsData = [], selectedRegionData } = generalSettingsStore;
    const { attributes = [] } = selectedRegionData;
    const updatedAttributes = attributes?.map((attr) => {
        const update = regionSettingsData?.find((data) => data.id === attr.id);
        const updateValue = update?.value || '';
        const assign = assignedItems?.find((data) => data.id === attr.id);
        let updated = { ...attr };
        if (update) {
            updated = { ...updated, value: updateValue };
        }
        if (assign) {
            updated = { ...updated, isAttributeAssigned: true };
        }
        return updated;
    });
    const updateRegion = { ...selectedRegionData, name: regionName, attributes: updatedAttributes };
    generalSettingsStore.setSelectedRegionData({ ...updateRegion });
};

export default updateRegionAttributeData;
